import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {UserService} from '../core/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate{
  constructor(
    private readonly router: Router,
    private readonly userService: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    const requiredRole = route.data.requiredRole as string;
    const allowedRoles = route.data.allowedRoles as string[];

    // Check if user has the required role or any of the allowed roles
    const hasAccess = this.userService.hasRole(requiredRole) || 
      (allowedRoles && allowedRoles.some(role => this.userService.hasRole(role)));

    if(!hasAccess){
      this.router.navigate(['not-authorized']);
      return false;
    }
    return true;
  }
}

